/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Placeholder_LocationInputs */

const en_jobs_placeholder_location = /** @type {(inputs: Jobs_Placeholder_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Munich, Germany`)
};

const de_jobs_placeholder_location = /** @type {(inputs: Jobs_Placeholder_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z.B. München, Deutschland`)
};

const fr_jobs_placeholder_location = /** @type {(inputs: Jobs_Placeholder_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex. Munich, Allemagne`)
};

const es_jobs_placeholder_location = /** @type {(inputs: Jobs_Placeholder_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ej. Múnich, Alemania`)
};

const it_jobs_placeholder_location = /** @type {(inputs: Jobs_Placeholder_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`es. Monaco di Baviera, Germania`)
};

const nl_jobs_placeholder_location = /** @type {(inputs: Jobs_Placeholder_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bijv. Amsterdam, Nederland`)
};

const pl_jobs_placeholder_location = /** @type {(inputs: Jobs_Placeholder_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`np. Monachium, Niemcy`)
};

const fi_jobs_placeholder_location = /** @type {(inputs: Jobs_Placeholder_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`esim. München, Saksa`)
};

const da_jobs_placeholder_location = /** @type {(inputs: Jobs_Placeholder_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`f.eks. München, Tyskland`)
};

const sv_jobs_placeholder_location = /** @type {(inputs: Jobs_Placeholder_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`t.ex. München, Tyskland`)
};

/**
* | output |
* | --- |
* | "e.g. Munich, Germany" |
*
* @param {Jobs_Placeholder_LocationInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_placeholder_location = /** @type {((inputs?: Jobs_Placeholder_LocationInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Placeholder_LocationInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_placeholder_location(inputs)
	if (locale === "fr") return fr_jobs_placeholder_location(inputs)
	if (locale === "es") return es_jobs_placeholder_location(inputs)
	if (locale === "it") return it_jobs_placeholder_location(inputs)
	if (locale === "nl") return nl_jobs_placeholder_location(inputs)
	if (locale === "pl") return pl_jobs_placeholder_location(inputs)
	if (locale === "fi") return fi_jobs_placeholder_location(inputs)
	if (locale === "da") return da_jobs_placeholder_location(inputs)
	if (locale === "sv") return sv_jobs_placeholder_location(inputs)
	return en_jobs_placeholder_location(inputs)
});